import React from "react"
import ReactDOM from "react-dom"
import { Select } from './Select'
import { Map } from './Map'
import { getData } from './api'
import "./index.css"
import "./responsive.css"

export const App = (props) => {
  let [data, setData] = React.useState({})
  let [cities, setCities] = React.useState([])
  let [places, setPlaces] = React.useState([])
  let [city, setCity] = React.useState()
  let [place, setPlace] = React.useState()
  let [mapState, setMapState] = React.useState({
    center: [55.751574, 37.573856],
    zoom: 5,
  })

  React.useEffect(
    () => { getData().then(
      (data) => {
        setData(data)
        setCities(data.cities.filter((city) => city.places.length > 0))
        setPlaces(data.places)
      }
    ) }, []
  )

  let handleCityChange = React.useCallback(
    (city) => {
      let places = city ? city.places : data.places
      setCity(city)
      setPlaces(places)
      if (city) {
        let { zoom, location } = city
        let center = [location.latitude, location.longitude]
        setMapState({ center, zoom })
      }
    }
  )

  let handlePlaceChange = React.useCallback(
    (place) => {
      setPlace(place)
      if (place) {
        let { zoom, location } = place
        let center = [location.latitude, location.longitude]
        setMapState({ center, zoom })
      }
    }
  )

  return (
    <div className='column'>
      <div className='row justify-center flex-wrap margin-20 padding-10'>
        <Select 
          options={cities}
          value={city}
          getValue={(city) => city?.name}
          onChange={handleCityChange}
          emptyValue='Выбор города'
          className='responsive-select'
        />
        <Select 
          options={places}
          value={place}
          getValue={(place) => place?.name}
          onChange={handlePlaceChange}
          emptyValue='Выбор метро'
          disabled={!city}
          className='responsive-select'
        />
      </div>
      <div className='map'>
        <Map mapState={mapState} coffeeShops={data.coffeeShops}/>
      </div>
    </div>
  )
}

